import React, { Component } from 'react'
import gsap from 'gsap'
import { throttle } from 'lodash';

import Button from '../pageContent/Button'

import Media from '../pageContent/Media'
import Clipper from './Clipper'

import Stars from './Animations/Stars'

class Slide extends Component {

    constructor(props){

        super(props)

        this.state = {
            progressX: 0,
            progressY: 0
        }

        this.animate = this.animate.bind(this)
        this.bind = this.bind.bind(this)
        this.removeBind = this.removeBind.bind(this)
        this.movement = this.movement.bind(this)
        this.getProgress = this.getProgress.bind(this)

    }

    bind(){
        
        this.slide.addEventListener('mousemove', this.cb)

    }
    
    removeBind(){
        
        this.slide.removeEventListener('mousemove', this.cb)

    }
    
    movement(e){
        
        const { viewport } = this.props
        
        const x = e.clientX
        const y = e.clientY

        const progressX = Math.ceil(x / viewport.width * 100)
        const progressY = Math.ceil(y / viewport.height * 100)

        this.setState({
            progressX,
            progressY
        })
        
    }

    getProgress(progress, total = 8, negative = false){

        let margin = 0;

        if(progress <= 50){
            
            margin = total - (total / 100 * (progress * 2))

        }
        else {
            margin = total + (total / 100 * (-progress * 2))
        }

        return !negative ? margin : margin * -1

    }


    componentDidMount(){

        this.cb = throttle(this.movement)

    }
    
    componentDidUpdate(prevProps){
        
        if(prevProps.shrink !== this.props.shrink){
            if(this.props.shrink){
                this.animate(0.8)
            } else {
                this.animate(1)
            }
        }

    }

    animate(scale){

        gsap.to(this.slide, {
            duration: 0.75,
            scale: scale,
            ease: 'power4.in'
        })

    }


    render() {

        const { fields, sys, isActive, viewport, progressX, progressY } = this.props

        const { project, description, teaser, branding } = fields

        const { id } = sys

        const txtStyle = {
            opacity: isActive ? 1 : 0,
            transform: isActive ? 'translateY(0)' : 'translateY(100px)'
        }
        
        const placeholderStyle = {
            opacity: !isActive ? 1 : 0
        }
        
        const clipperStyle = {
        }
        
        const barTopStyle = {
            backgroundPosition: `${this.getProgress(progressX, 100)}px 0`,
            opacity: isActive ? 1 : 0
        }
        
        const barSideStyle = {
            backgroundPosition: `0 ${this.getProgress(progressY, 100)}px`,
            opacity: isActive ? 1 : 0
        }
       
        
        return (

            <div ref={slide => { this.slide = slide }} style={branding} className='slide' aria-hidden={!isActive}>

                {isActive && viewport.width > 0 && 
                    <Stars viewport={viewport} isActive={isActive} />
                }

                <div className="barTop" style={barTopStyle}></div>
                <div className="barSide" style={barSideStyle}></div>
                
                
                <div className="placeholder text-center" style={placeholderStyle}>
                    <div className="hr-container">
                        <hr />
                    </div>
                    <p>{project}</p>
                </div>

                <div className="cell">

                    <div className="grid">

                        <div className="unit half xs-text-center">
                        
                            <div className="txt">

                                <hr style={txtStyle} />
                                
                                <h2 style={txtStyle} className="mb5">{project}</h2>
                                <div style={txtStyle} className='slide__clipped'>
                                    <p>
                                        {description}
                                    </p>
                                </div>
                                <p style={txtStyle} className="btn-container">
                                    <Button className="poke" to={`/work/${id}`} tabIndex={isActive ? 0 : -1}>More on {project}</Button>
                                </p>
                                
                            </div>
                        </div>
                    
                        <div className="unit half rebel hide-on-mobiles">

                            {isActive && viewport.width > 0 && 
                                
                                <Clipper clipperStyle={clipperStyle}>
                                    <Media data={teaser} />                                    
                                </Clipper>
                            
                            }

                        </div>


                    </div>

                </div>

            </div>

        );
    }
}

export default Slide;
